
import { ServerEventConnect, ServerEventJoin, ServerEventLeave, ServerEventMessage, ServerEventUpdate } from '@servicestack/client';
import { createContext } from "react";


export interface IServerSentEventOnConnect {
    (connect: ServerEventConnect): void | Promise<void>;
}

export interface IServerSentEventOnJoin {
    (join: ServerEventJoin): void | Promise<void>;
}

export interface IServerSentEventOnLeave {
    (leave: ServerEventLeave): void | Promise<void>;
}

export interface IServerSentEventOnUpdate {
    (update: ServerEventUpdate): void | Promise<void>;
}

export interface IServerSentEventOnMessage<TData = any> {
    (data: TData, message: ServerEventMessage): void | Promise<void>;
}

export interface IServerSentEventOnException<TError = any> {
    (error: TError): void | Promise<void>;
}

export interface IServerSentEventOnReconnect<TError = any> {
    (error: TError): void | Promise<void>;
}

export interface IServerSentEventOnTick {
    (message: ServerEventMessage): void | Promise<void>;
}

export interface IServerSentEventUnsubscribe {
    (): void;
}

export interface IServerSentEventsListeners {
    onConnect: IServerSentEventOnConnect[];
    onJoin: IServerSentEventOnJoin[];
    onLeave: IServerSentEventOnLeave[]; 
    onUpdate: IServerSentEventOnUpdate[];
    onMessage: IServerSentEventOnMessage[],
    onException: IServerSentEventOnException[],
    onReconnect: IServerSentEventOnReconnect[],
    onTick: IServerSentEventOnTick[]
}

export interface IServerSentEventsContext {
    addOnConnectListener: (channel: string, listener: IServerSentEventOnConnect) => IServerSentEventUnsubscribe;
    addOnJoinListener: (channel: string, listener: IServerSentEventOnJoin) => IServerSentEventUnsubscribe;
    addOnLeaveListener: (channel: string, listener: IServerSentEventOnLeave) => IServerSentEventUnsubscribe;
    addOnUpdateListener: (channel: string, listener: IServerSentEventOnUpdate) => IServerSentEventUnsubscribe;
    addOnMessageListener: <TData = any>(channel: string, listener: IServerSentEventOnMessage<TData>) => IServerSentEventUnsubscribe;
    addOnExceptionListener: <TError = any>(channel: string, listener: IServerSentEventOnException<TError>) => IServerSentEventUnsubscribe;
    addOnReconnectListener: <TError = any>(channel: string, listener: IServerSentEventOnReconnect<TError>) => IServerSentEventUnsubscribe;
    addOnTickListener: (channel: string, listener: IServerSentEventOnTick) => IServerSentEventUnsubscribe;
}

export const ServerSentEventsContext = createContext<IServerSentEventsContext>({
    //@ts-expect-error
    addOnConnectListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnExceptionListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnJoinListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnLeaveListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnMessageListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnReconnectListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnTickListener: (channel, listener) => {
        return () => {};
    },
    //@ts-expect-error
    addOnUpdateListener: (channel, listener) => {
        return () => {};
    }
});

export default ServerSentEventsContext;